import { Box, Skeleton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const AddressSkeleton = () => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        <Skeleton width={150} />
      </Typography>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {[...Array(4)].map((_, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <Skeleton variant="rounded" width={"100%"} height={150} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
